<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-image
            style="margin-left: 16px;"
            width="100"
            height="100"
            fit="cover"
            :src="inputForm.photo"
        />
        <van-field v-model="inputForm.name" label="姓名" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.idcarNo" label="身份证号码" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.sexLabel" label="性别" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.joinTime" label="入职时间" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.birthday" label="出生年月" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.joinAge" label="入职年龄" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.workTime" label="参加工作时间" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.stature" label="身高（米）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.weight" label="体重（公斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.phone" label="联系电话" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.famillyPhone" label="家庭电话" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.email" label="电子邮箱" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.politicVisgaeLabel" label="政治面貌" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.eduLevelLabel" label="学历" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.degreeLabel" label="学位" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.major" label="专业" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.graduateSchool" label="毕业院校" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.graduateDate" label="毕业日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.studyTypeLabel" label="学习形式" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.hukouAddress" label="户籍地址" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.nativePlace" label="籍贯" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.hukouPropertyLabel" label="户口性质" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.famillyAddress1" label="家庭地址1" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.nation" label="民族" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.maritalStatusLabel" label="婚姻状况" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.famillyAddress2" label="家庭地址2" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.legalRetireTime" label="法定退休日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.flexibleRetireTime" label="弹性退休年月" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.urgentName" label="紧急联系人" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.urgentRemark" label="与本人关系" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.urgentPhone" label="紧急联系电话" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.regDate" label="登记日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
          <p style="color: #AAA">附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="人事信息" name="2">
        <van-field v-model="inputForm.corpName" label="公司名称" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.orgName" label="部门名称" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.stationName" label="岗位名称" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.stationCategoryLabel" label="岗位类别" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.dutyName" label="职务名称" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.regularTime" label="转正时间" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.stationNames" label="副岗信息" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.socialAcct" label="社保代码" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.gjjAcct" label="公积金代码" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.bankAcct" label="工资银行卡号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.bankName" label="开户银行" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractTypeLabel" label="劳动合同类型" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractPropertyLabel" label="劳动合同性质" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractTerm" label="劳动合同期限" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.authEmployeeName" label="考勤员" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.employeeNo" label="员工编号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.employeeStatusLabel" label="员工状态" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.regularStatusLabel" label="在职状态" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.regularStatus === '20'" v-model="inputForm.employeeTypeName" label="员工类型" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>

      <van-collapse-item title="面试信息" name="3">
        <van-field v-model="inputForm.regSourceArrLabel" label="求职信息来源" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.judge.judgeTime" label="面试时间" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.judge.judgeName" label="面试考官" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.salaryHope" label="期望月薪酬" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.salaryTrial" label="试用期月薪酬" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>

      <van-collapse-item title="其他信息" name="4" v-show="inputForm.educateExpArr.length > 0 || inputForm.trainExpArr.length > 0 || inputForm.workExpArr.length > 0 || inputForm.familyRelArr.length > 0 || inputForm.socialRelArr.length > 0">
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px" v-show="inputForm.educateExpArr.length > 0">
          <p style="display: block; color: #4caedc" @click="viewDetail()">查看学习经历</p>
        </div>
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px" v-show="inputForm.trainExpArr.length > 0">
          <p style="display: block; color: #4caedc" @click="viewDetail2()">查看培训经历</p>
        </div>
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px" v-show="inputForm.workExpArr.length > 0">
          <p style="display: block; color: #4caedc" @click="viewDetail3()">查看工作经历</p>
        </div>
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px" v-show="inputForm.familyRelArr.length > 0">
          <p style="display: block; color: #4caedc" @click="viewDetail4()">查看家庭主要成员情况</p>
        </div>
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px" v-show="inputForm.socialRelArr.length > 0">
          <p style="display: block; color: #4caedc" @click="viewDetail5()">查看主要社会关系</p>
        </div>
      </van-collapse-item>

    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "@/components/processRecord/processRecord.vue";
import TaskService from "@/api/flowable/TaskService";
import ProcessService from "@/api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
export default {
  name: "HrEmployee",
  data(){
    return {
      activeNames: ['1', '2', '3', '4'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        educateExpArr: [],
        trainExpArr: [],
        workExpArr: [],
        familyRelArr: [],
        socialRelArr: [],
        attachList: [],
        judge: {},
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'hr_employee',
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/hr/employee/hrEmployee/queryById').then(({ data }) => {
        this.inputForm = data
        this.inputForm.educateExpArr = []
        this.inputForm.trainExpArr = []
        this.inputForm.workExpArr = []
        this.inputForm.familyRelArr = []
        this.inputForm.socialRelArr = []
        if (!data.attachIds) {
          this.inputForm.attachList = []
        }
        // 面试信息
        if (this.inputForm.judgeExp) {
          this.inputForm.judge = JSON.parse(this.inputForm.judgeExp);
        }
        // checkbox回显
        if (this.inputForm.regSource && this.inputForm.regSource !== '') {
          this.inputForm.regSourceArr = this.inputForm.regSource.split(',');
        } else {
          this.inputForm.regSourceArr = [];
        }
        this.getDict([
          ['hr_comm_sex', 'sex'],
          ['hr_politic_visgae', 'politicVisgae'],
          ['hr_edu_level', 'eduLevel'],
          ['hr_degree_type', 'degree'],
          ['hr_hire_study_type', 'studyType'],
          ['hr_hukou_property', 'hukouProperty'],
          ['hr_marital_status', 'maritalStatus'],
          ['hr_station_category', 'stationCategory'],
          ['hr_contract_type', 'contractType'],
          ['hr_contract_property', 'contractProperty'],
          ['hr_employee_status', 'employeeStatus'],
          ['hr_regular_status', 'regularStatus'],
        ])
        if(data.regularStatus === '20') {
          this.getDicts([
            ['hr_employee_type', 'employeeType']
          ])
        }
        this.getDicts([
          ['hr_hire_reg_source', 'regSourceArr']
        ])

        this.$flow.queryByParams({
          employeeId: id
        }, '/hr/employee/comm/queryExpByEmployeeId').then(res => {
           this.inputForm.educateExpArr = res.data.educateExpArr || []
           this.inputForm.trainExpArr = res.data.trainExpArr || []
          this.inputForm.workExpArr = res.data.workExpArr || []
          this.inputForm.familyRelArr = res.data.familyRelArr || []
          this.inputForm.socialRelArr = res.data.socialRelArr || []

          if(this.inputForm.familyRelArr && this.inputForm.familyRelArr.length > 0) {
            this.updateDictNames(this.inputForm.familyRelArr,{hr_comm_relation_type:'relTypeId'})
          }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          // 判空处理：只有当表单字段有值时才处理
          if (this.inputForm[formField] !== null && this.inputForm[formField] !== undefined && this.inputForm[formField] !== '') {
            const dictList = data[dictType] || [];
            const dictItem = dictList.find(item => item.value == this.inputForm[formField]);
            this.$set(this.inputForm, `${formField}Label`, dictItem ? dictItem.label : '');
          } else {
            // 表单字段为空时，清空标签字段
            this.$set(this.inputForm, `${formField}Label`, '');
          }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    getDicts(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        // 遍历每个需要处理的字典类型和表单字段映射
        dicts.map(([dictType, formField]) => {
          // 1. 先获取当前表单字段的数组值
          const fieldValueArr = this.inputForm[formField];
          // 2. 校验值是否为有效数组，避免空值/非数组导致报错
          if (Array.isArray(fieldValueArr) && fieldValueArr.length > 0) {
            // 3. 遍历数组，把每个值映射为对应的标签（去掉可选链，手动判空）
            const labelArr = fieldValueArr.map(value => {
              // 先判断 data[dictType] 是否存在，再执行 find
              let dictItem = null;
              if (data[dictType]) {
                dictItem = data[dictType].find(item => item.value == value);
              }
              // 兜底：如果没找到对应字典项，返回原值或空字符串
              return dictItem ? dictItem.label : '';
            });
            // 拼接为字符串（如用逗号分隔）
            this.$set(this.inputForm, `${formField}Label`, labelArr.join(','));
          } else {
            // 空数组/非数组时，清空标签字段
            this.$set(this.inputForm, `${formField}Label`, []); // 或 ''（对应字符串拼接）
          }
        });
      }).catch(e => {
        console.error('获取字典失败：', e);
      });
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Name`, dictItem.label);
            }
          }
        }
      });
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/hr/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          _this.$flow.startFlow(form, '/hr/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    viewDetail(){
      this.$router.push({
        path: '/educationExperienceDetail',
        query: {
          data: JSON.stringify(this.inputForm.educateExpArr),
        }
      })
    },
    viewDetail2(){
      this.$router.push({
        path: '/trainingExperienceDetail',
        query: {
          data: JSON.stringify(this.inputForm.trainExpArr),
        }
      })
    },
    viewDetail3(){
      this.$router.push({
        path: '/workExperienceDetail',
        query: {
          data: JSON.stringify(this.inputForm.workExpArr),
        }
      })
    },
    viewDetail4(){
      this.$router.push({
        path: '/familyMemberDetail',
        query: {
          data: JSON.stringify(this.inputForm.familyRelArr),
        }
      })
    },
    viewDetail5(){
      this.$router.push({
        path: '/mainSocialDetail',
        query: {
          data: JSON.stringify(this.inputForm.socialRelArr),
        }
      })
    },
  }
}
</script>

<style scoped>

</style>